/* nsh-consent.js v3.1 (2026-10-21). ASCII only except the v3.1 note line.
   v3.1 (2026-10-21): EU·UK 미동의 시 식별값 제거 켬 -- OPTIN_STRIP_IDS = true (mirror of assets/nsh-quiz-track.js v5.1).
   v3: region modes (decided in the snippet's head part, kept in window.NSH_CONSENT_STATE.mode):
       'optin'  = the v2 dialog below, unchanged (blocking until a choice, defaults denied).
       'notice' = no dialog; analytics/ads run by default (state.auto = true, nothing stored, Shopify not told).
                  The footer link opens a notice panel (view "note"): keep (= explicit all) / turn off (= explicit
                  essential). A notice visitor who already turned it off gets the v2 switch view to turn it back on.
       A first visit on a page with the Shopify API may still be deciding (state.pending); the head part then fires
       'nsh:region' {mode}; 'optin' opens the dialog here.
     - every explicit choice (never the automatic default, never a reload) sends the record 'consent_choice'
       {value:'all'|'essential', extra:{consent, mode, test}} to the same Apps Script endpoint as the quiz
       (via nsh-quiz-track.js v5 when it is on the page, else a minimal record from here).
     - window.NSH_CONSENT.state() -> {chosen, analytics, ads, mode, auto}.
   v2 notes follow.
   Cookie consent dialog. Markup and copy: snippets/nsh-consent.liquid. Look: assets/nsh-consent.css.
   v2: one switch now covers analytics AND ad measurement. Record version bumped to 2, so every
       v1 choice (analytics only) is asked again.
   The snippet's head part has already
     - set Google consent defaults (everything denied unless a stored v2 choice granted it),
     - loaded GTM only for visitors who granted before (window.NSH_GTM),
     - added html.nsh-cc-open when no choice is stored, and cloned the dialog out of its <template>.
   This file
     - opens and closes the dialog (blocking: the first choice is required; Escape works only once a choice exists),
     - stores the choice in localStorage 'nsh_consent' {v:2, a:analytics+ads, t:time, s:passed to Shopify},
     - updates Google consent (analytics_storage + ad_storage + ad_user_data + ad_personalization),
       loads GTM on consent, disables GA4 and removes GA cookies on refusal,
     - passes the same choice to Shopify Customer Privacy (analytics and marketing, so app pixels such as
       Meta follow it). The quiz page has no content_for_header, so a choice made there is passed on at the
       next page that has the API (record field s: 1 once Shopify has it),
     - tells other scripts with the window event 'nsh:consent' {detail:{analytics, ads}} (nsh-quiz-track.js v4 held its
       Apps Script records until then; v5 sends at once),
     - reopens on the footer link: a[href$="#cookie-settings"] or [data-nsh-consent-open], or window.NSH_CONSENT.open(). */
(function (w, d) {
  if (w.__NSH_CC) return;
  w.__NSH_CC = 1;
  var KEY = 'nsh_consent', VER = 2, GA = 'ga-disable-G-94Z9G90J8M', html = d.documentElement;
  var st = w.NSH_CONSENT_STATE || { chosen: false, analytics: false, ads: false, mode: 'optin', auto: false };
  w.NSH_CONSENT_STATE = st;
  var root = null, card = null, vMain = null, vSet = null, vNote = null, sw = null, lastFocus = null, inerted = [];
  /* Same Apps Script web app as NSH_TRACK_ENDPOINT in assets/nsh-quiz-engine-2.js (that constant only exists on the
     quiz page, so it is copied here for consent_choice on theme pages). Keep the two equal. */
  var ENDPOINT = 'https://script.google.com/macros/s/AKfycbxr1dl9VHWm1hKlUFozrDeXNlg-Y-Z_l6FizSU9IE2Llf_9mdeSnv5sHgyP9aj5UfeEfg/exec';
  /* Mirror of OPTIN_STRIP_IDS in assets/nsh-quiz-track.js (legal review switch). true = in 'optin' mode a record
     whose consent is not 'all' leaves without sid. Keep the two equal. */
  var OPTIN_STRIP_IDS = true;

  function mount() {
    if (root) return true;
    root = d.getElementById('nsh-cc');
    if (!root) {
      var t = d.getElementById('nsh-cc-tpl');
      if (!t || !t.content) return false;
      t.parentNode.insertBefore(t.content.cloneNode(true), t);
      root = d.getElementById('nsh-cc');
      if (!root) return false;
    }
    card = root.querySelector('.nsh-cc__card');
    vMain = root.querySelector('[data-cc-view="main"]');
    vSet = root.querySelector('[data-cc-view="set"]');
    vNote = root.querySelector('[data-cc-view="note"]');
    sw = root.querySelector('[data-cc="sw"]');
    root.addEventListener('click', onClick);
    root.addEventListener('keydown', onKey);
    root.addEventListener('keyup', stop);
    root.addEventListener('keypress', stop);
    return true;
  }

  function stop(e) { e.stopPropagation(); }

  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (x) {} }
  }

  function read() {
    try { var c = JSON.parse(w.localStorage.getItem(KEY) || 'null'); return c && c.v === VER ? c : null; } catch (e) { return null; }
  }
  function store(a) {
    try { w.localStorage.setItem(KEY, JSON.stringify({ v: VER, a: a, t: Date.now(), s: 0 })); } catch (e) {}
  }
  function markSynced() {
    var c = read();
    if (!c) return;
    c.s = 1;
    try { w.localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
  }

  function clearGa() {
    var host = location.hostname, parts = host.split('.'), doms = ['', host, '.' + host], i;
    for (i = 1; i < parts.length - 1; i++) doms.push('.' + parts.slice(i).join('.'));
    (d.cookie || '').split(';').forEach(function (s) {
      var n = s.split('=')[0].replace(/^\s+|\s+$/g, '');
      if (/^(_ga|_ga_\w+|_gid|_gat\w*|_gcl_\w+)$/.test(n)) {
        doms.forEach(function (dm) { d.cookie = n + '=; Max-Age=0; path=/' + (dm ? '; domain=' + dm : ''); });
      }
    });
  }

  function shopify(a) {
    var S = w.Shopify;
    if (!S) return;
    function go() {
      try { S.customerPrivacy.setTrackingConsent({ analytics: a, marketing: a }, function (r) { if (!(r && r.error)) markSynced(); }); } catch (e) {}
    }
    if (S.customerPrivacy && typeof S.customerPrivacy.setTrackingConsent === 'function') { go(); return; }
    if (typeof S.loadFeatures === 'function') {
      try { S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) go(); }); } catch (e) {}
    }
  }

  function choose(a) {
    a = !!a;
    store(a);
    st.chosen = true;
    st.analytics = a;
    st.ads = a;
    st.auto = false;
    st.pending = false;
    w.NSH_CONSENT_STATE = st;
    var g = a ? 'granted' : 'denied';
    try { w.gtag('consent', 'update', { analytics_storage: g, ad_storage: g, ad_user_data: g, ad_personalization: g }); } catch (e) {}
    if (a) {
      w[GA] = false;
      if (typeof w.NSH_GTM === 'function') w.NSH_GTM();
    } else {
      w[GA] = true;
      clearGa();
    }
    shopify(a);
    try { w.dispatchEvent(new CustomEvent('nsh:consent', { detail: { analytics: a, ads: a } })); } catch (e) {}
    sendChoice(a);
    close();
  }

  /* consent_choice: explicit choices only (choose() is reached from the buttons, never from defaults or reloads) */
  function attrs() { try { return JSON.parse(w.sessionStorage.getItem('nshAttr') || 'null') || {}; } catch (e) { return {}; } }
  function isTest(at) {
    if (at && at.test) return true;
    try { return new URL(location.href).searchParams.get('test') === '1'; } catch (e) { return false; }
  }
  function sendChoice(a) {
    var v = a ? 'all' : 'essential';
    if (typeof w.NSH_TRACK_LOG === 'function') { try { w.NSH_TRACK_LOG('consent_choice', { value: v }); return; } catch (e) {} }
    var at = attrs(), lm = /^\/(ko|ja)(\/|$)/.exec(location.pathname);
    var rec = { event: 'consent_choice', ts: new Date().toISOString(), locale: lm ? lm[1] : 'en', value: v };
    if (at.sid && !(OPTIN_STRIP_IDS && st.mode === 'optin' && !a)) rec.sid = at.sid;
    rec.extra = { consent: v, mode: st.mode === 'notice' ? 'notice' : 'optin' };
    if (isTest(at)) rec.extra.test = 1;
    try { if (navigator.sendBeacon) navigator.sendBeacon(ENDPOINT, new Blob([JSON.stringify(rec)], { type: 'text/plain;charset=UTF-8' })); } catch (e) {}
  }

  function show(view) {
    if (view === 'note' && !vNote) view = 'set';
    vMain.hidden = view !== 'main';
    vSet.hidden = view !== 'set';
    if (vNote) vNote.hidden = view !== 'note';
    if (view === 'note') { root.setAttribute('aria-describedby', 'nsh-cc-ntd'); }
    else root.setAttribute('aria-describedby', 'nsh-cc-d');
    if (view === 'set') sw.setAttribute('aria-checked', st.analytics ? 'true' : 'false');
  }
  /* footer / #cookie-settings: notice mode gets the notice panel unless the visitor already turned it off */
  function settingsView() { return st.mode === 'notice' && !(st.chosen && !st.analytics) ? 'note' : 'set'; }
  function blocking() { return !st.chosen && st.mode !== 'notice'; }

  function open(view) {
    if (!mount()) return;
    if (!html.classList.contains('nsh-cc-open') || !lastFocus) lastFocus = d.activeElement;
    html.classList.add('nsh-cc-open');
    show(view);
    inerted.forEach(function (el) { el.removeAttribute('inert'); });
    inerted = [];
    Array.prototype.forEach.call(d.body.children, function (el) {
      if (el === root || el.contains(root) || el.tagName === 'SCRIPT' || el.tagName === 'TEMPLATE' || el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      inerted.push(el);
    });
    focusEl(card);
  }

  function close() {
    html.classList.remove('nsh-cc-open');
    inerted.forEach(function (el) { el.removeAttribute('inert'); });
    inerted = [];
    if (lastFocus && lastFocus !== d.body && d.contains(lastFocus)) focusEl(lastFocus);
    lastFocus = null;
  }

  function onClick(e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cc]') : null;
    if (!b || !root.contains(b)) return;
    var k = b.getAttribute('data-cc');
    if (k === 'all') choose(true);
    else if (k === 'min') choose(false);
    else if (k === 'set') { show('set'); focusEl(sw); }
    else if (k === 'back') { show('main'); focusEl(root.querySelector('[data-cc="set"]')); }
    else if (k === 'sw') sw.setAttribute('aria-checked', sw.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
    else if (k === 'save') choose(sw.getAttribute('aria-checked') === 'true');
    else if (k === 'keep') choose(true);
    else if (k === 'off') choose(false);
  }

  function focusables() {
    var v = !vMain.hidden ? vMain : !vSet.hidden ? vSet : (vNote || vSet);
    return Array.prototype.filter.call(v.querySelectorAll('a[href],button'), function (x) {
      return !x.disabled && x.offsetParent !== null;
    });
  }

  function onKey(e) {
    if (e.key === 'Tab') {
      var f = focusables();
      if (f.length) {
        var first = f[0], last = f[f.length - 1], a = d.activeElement;
        if (e.shiftKey && (a === first || a === card || !root.contains(a))) { e.preventDefault(); focusEl(last); }
        else if (!e.shiftKey && (a === last || !root.contains(a))) { e.preventDefault(); focusEl(first); }
      }
    } else if ((e.key === 'Escape' || e.key === 'Esc') && !blocking()) {
      e.preventDefault();
      close();
    }
    e.stopPropagation();
  }

  /* keep focus inside while open (inert does this too; this covers browsers without inert) */
  d.addEventListener('focusin', function (e) {
    if (root && html.classList.contains('nsh-cc-open') && !root.contains(e.target)) focusEl(card);
  });

  /* reopen: footer link or any link to #cookie-settings */
  d.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-nsh-consent-open],a[href$="#cookie-settings"]') : null;
    if (!t || (root && root.contains(t))) return;
    e.preventDefault();
    open(settingsView());
  });
  function fromHash() {
    if (location.hash !== '#cookie-settings') return;
    open(settingsView());
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
  }
  w.addEventListener('hashchange', fromHash);

  w.NSH_CONSENT = {
    open: function () { open(settingsView()); },
    state: function () { return { chosen: !!st.chosen, analytics: !!st.analytics, ads: !!st.analytics, mode: st.mode === 'notice' ? 'notice' : 'optin', auto: !!st.auto }; }
  };

  /* first visit on a theme page: the head part decided the region after this file may have run */
  w.addEventListener('nsh:region', function (e) {
    var m = e && e.detail && e.detail.mode;
    if (m === 'optin' && !st.chosen && !(root && html.classList.contains('nsh-cc-open') && !vMain.hidden)) open('main');
  });

  (function () {
    var c = read();
    if (st.chosen && c && c.s !== 1) shopify(!!c.a);
  })();

  if (html.classList.contains('nsh-cc-open')) open('main');
  else fromHash();
})(window, document);
